import { Flex, Tag } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import IconAsText from 'src/components/IconAsText';
import { ClearCardContainer, ModuleCardContainer, ModuleDescription, ModuleTitle } from 'src/pages/store/components/ModulesList/styles';
import { IModulesListComponent } from 'src/pages/store/components/ModulesList/types';
import { IoClose } from 'react-icons/io5';

export default function ModulesList({
	modules,
	selectedModule,
	onModuleSelect,
}: IModulesListComponent) {
	const containerRef = useRef<HTMLDivElement>(null);
	const [ isTouching, setIsTouching, ] = useState(false);
	const [ startX, setStartX, ] = useState(0);
	const [ scrollLeft, setScrollLeft, ] = useState(0);

	useEffect(() => {
		const container = containerRef.current;
		if (!container) return;

		const handleWheel = (event: WheelEvent) => {
			event.preventDefault();
			const scrollAmount = event.deltaY;
			container.scrollTo({
				top: 0,
				left: container.scrollLeft + scrollAmount,
			});
		};

		container.addEventListener('wheel', handleWheel, { passive: false, });

		return () => {
			container.removeEventListener('wheel', handleWheel);
		};
	}, []);

	const handleTouchStart = (event: React.TouchEvent<HTMLDivElement>) => {
		const container = containerRef.current;
		if (!container) return;

		setIsTouching(true);
		setStartX(event.touches[0].pageX - container.offsetLeft);
		setScrollLeft(container.scrollLeft);
	};

	const handleTouchMove = (event: React.TouchEvent<HTMLDivElement>) => {
		const container = containerRef.current;
		if (!isTouching || !container) return;
		event.preventDefault();

		const x = event.touches[0].pageX - container.offsetLeft;
		const walk = (x - startX) * 2;
		container.scrollLeft = scrollLeft - walk;
	};

	const handleTouchEnd = () => {
		setIsTouching(false);
	};

	return (
		<Flex
			ref={containerRef}
			gap={16}
			align='center'
			style={{ overflow: 'hidden', paddingLeft: '8px', }}
			onTouchStart={handleTouchStart}
			onTouchMove={handleTouchMove}
			onTouchEnd={handleTouchEnd}
		>
			{selectedModule && (
				<ClearCardContainer onClick={() => onModuleSelect(null)}>
					<IoClose fontSize={20} color='#D9D9D9' />
				</ClearCardContainer>
			)}
			{modules?.map((module, i) => (
				<ModuleCardContainer
					key={i}
					onClick={() => onModuleSelect(module)}
				>
					<Flex gap={12} align='center'>
						<IconAsText
							// @ts-ignore
							icon={module.icon}
							fontSize={24}
						/>
						<Flex gap={4} align='end'>
							<ModuleTitle>{module.name}</ModuleTitle>
							<Tag color='#1677FF'>{module.target}</Tag>
						</Flex>
					</Flex>
					<ModuleDescription>{module.short_description}</ModuleDescription>
					{/* <Flex gap={4}>
						{[ 'teste', 'teste2', 'teste3', ].map((tag, i) => (
							<Tag
								key={i}
								style={{ margin: 0, }}
							>
								{tag}
							</Tag>
						))}
					</Flex> */}
				</ModuleCardContainer>
			))}
		</Flex>
	);
}
